import { Icon, IconType } from "assets/icons";
import React, { PropsWithChildren } from "react";
import classNames from "classnames";

import { Paragraph } from "components/Paragraph/Paragraph";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import styles from "./styles.module.scss";

export enum EButtonVariant {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TERTIARY = "TERTIARY",
}

export type ButtonProps = {
  icon?: IconType;
  onClick?: VoidFunction;
  variant?: EButtonVariant;
  className?: string;
  disabled?: boolean;
};

export const Button = (props: PropsWithChildren<ButtonProps>): JSX.Element => {
  const {
    children,
    icon,
    onClick,
    variant = EButtonVariant.PRIMARY,
    className,
    disabled,
  } = props;

  return (
    <span
      onClick={disabled ? undefined : onClick}
      className={classNames(
        styles.button,
        className,
        "py-1 px-2 cursor-pointer",
        {
          [styles.primary]: variant === EButtonVariant.PRIMARY,
          [styles.secondary]: variant === EButtonVariant.SECONDARY,
          [styles.tertiary]: variant === EButtonVariant.TERTIARY,
          [styles.disabled]: disabled,
        }
      )}
    >
      {!!icon && <Icon type={icon} size={16} />}
      {!!icon && !!children && <HorizontalSpace size={4} />}
      <Paragraph fontSize={12}>{children}</Paragraph>
    </span>
  );
};
